import type {
  LC_FractionalLeaveItemOut,
  LC_FractionalLeaveToggleStatusOut,
  LC_FractionalLeaveUpdateOut,
  LC_FractionalLeaveCreateOut,
  FractionalLeave,
  FractionalLeavePage,
} from './fractionalLeave.types';


// ── Hours format helpers ──────────────────────────────────────────────────

/** Backend sends HH:mm:ss — return value as-is (preserve seconds when present) */
export function normalizeHoursFromBackend(hours: string | null): string {
  if (!hours) return '';
  return hours;
}

// ── Single record mapper ───────────────────────────────────────────────────

type LC_AnyFractionalLeaveOut =
  | LC_FractionalLeaveItemOut
  | LC_FractionalLeaveToggleStatusOut
  | LC_FractionalLeaveUpdateOut
  | LC_FractionalLeaveCreateOut;

export function mapFractionalLeaveToModel(record: LC_AnyFractionalLeaveOut): FractionalLeave {
  return {
    id: record.id,
    name: record.name ?? '',
    description: record.description ?? '',
    hours: normalizeHoursFromBackend(record.hours),
    deductible: record.deductible,
    isActive: record.isActive,
  };
}

// ── Paged result mapper ────────────────────────────────────────────────────

export function mapFractionalLeavePagedResultToModel(pagedResult: {
  data: LC_FractionalLeaveItemOut[] | null;
  pagination?: { totalRecords?: number };
}): FractionalLeavePage {
  return {
    data: pagedResult.data?.map(mapFractionalLeaveToModel) ?? [],
    totalRecords: pagedResult.pagination?.totalRecords ?? 0,
  };
}
